import React, { useState, useRef } from "react";
import { Input, Button, message, Form, Steps, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import "./style.css";

const CustomerOnBoarding = ({ onNext, onCancel, initialValues }) => {
  const [form] = Form.useForm();

  const handleCancel = () => {
    form.resetFields();
    message.info("Changes canceled");
  };

  const handleNext = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      onNext(values);
    } catch (err) {
      console.log("Validation Failed:", err);
    }
  };

  return (
    <div className="customer-form">
      <Form form={form} layout="vertical" initialValues={initialValues}>
        <div className="add-container">
          <div className="heading">Customer Onboarding</div>
          <div className="details">
            <div className="input-group">
              <div className="title">Customer Name</div>
              <Form.Item
                name="customerName"
                rules={[
                  {
                    required: true,
                    message: "Please enter customer name",
                  },
                ]}
              >
                <Input placeholder="Enter Customer Name" />
              </Form.Item>
            </div>
            <div className="input-group">
              <div className="title">Phone Number</div>
              <Form.Item
                name="customerPhone"
                rules={[
                  {
                    required: true,
                    message: "Please enter phone number",
                  },
                ]}
              >
                <PhoneInput
                  country={"jm"}
                  placeholder="Enter Phone Number"
                  inputClass="phone-input"
                  specialLabel={false}
                  onChange={(value) => {
                    form.setFieldsValue({
                      customerPhone: value.startsWith("+")
                        ? value
                        : `+${value}`,
                    });
                  }}
                />
              </Form.Item>
            </div>
            <div className="input-group">
              <div className="title">Email Address</div>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please enter an email address",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input placeholder="Enter Email Address" />
              </Form.Item>
            </div>
            <div className="input-group">
              <div className="title">API Key</div>
              <Form.Item
                name="api_key"
                rules={[{ required: true, message: "Please enter API key" }]}
              >
                <Input placeholder="Enter API Key" />
              </Form.Item>
            </div>

            <div className="input-group">
              <div className="title">Domain</div>
              <Form.Item
                name="domain"
                rules={[
                  { required: true, message: "Please enter your domain" },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();

                      if (!value.startsWith("https://")) {
                        return Promise.reject(
                          new Error("Domain must start with https://")
                        );
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input placeholder="Enter Domain" />
              </Form.Item>
            </div>

            <div className="input-group">
              <div className="title">Secret Pin</div>
              <Form.Item
                name="pin"
                rules={[
                  {
                    required: true,
                    message: "Please enter your Secret Pin",
                  },
                  {
                    pattern: /^\d{4}$/,
                    message: "Pin must be exactly 4 numeric digits",
                  },
                ]}
              >
                <Input.Password placeholder="Enter Secret Pin" maxLength={4} />
              </Form.Item>
            </div>

            <div className="input-group">
              <Form.Item
                name="logo"
                valuePropName="fileList"
                getValueFromEvent={(e) => e && e.fileList}
                rules={[
                  {
                    required: true,
                    message: "Please upload a profile photo",
                  },
                ]}
              >
                <Upload
                  accept=".png,.jpg,.jpeg,.jfif"
                  listType="picture"
                  maxCount={1}
                  beforeUpload={(file) => {
                    const allowedExtensions = ["png", "jpg", "jpeg", "jfif"];
                    const fileExtension = file.name
                      .split(".")
                      .pop()
                      .toLowerCase();

                    if (!allowedExtensions.includes(fileExtension)) {
                      message.error(
                        "Only image files (.png, .jpg, .jpeg, .jfif) are allowed",
                      );
                      return Upload.LIST_IGNORE;
                    }

                    return false;
                  }}
                >
                  <Button className="upload-btn" icon={<PlusOutlined />}>
                    Attach Profile Photo
                  </Button>
                </Upload>
              </Form.Item>
            </div>
          </div>
        </div>
      </Form>

      <div className="form-actions">
        <Button onClick={handleCancel}>Cancel</Button>
        <Button
          className="save-btn"
          type="primary"
          onClick={() => {
            handleNext();
          }}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default CustomerOnBoarding;
